// Module
var code = "<popup-survey-directive ng-click=\"!surveyPopup.openedPopup && surveyPopup.recordView()\" survey=\"surveyPopup.survey\" expand-survey=\"expandSurvey\" company-branding=\"surveyPopup.companyBranding\" complete-fn=\"surveyPopup.complete\" user-language=\"surveyPopup.userLanguage\"></popup-survey-directive> ";
// Exports
module.exports = code;